import { Config } from '#lib/constants/config.js';

export const Links = Object.freeze({
	ContactUs: '/faq/contact-us',
	Faq: '/faq',
	Vault: `${Config.Domain}/faq/more-from-heni/heni-vault`,
	HeniNewsFaq: `${Config.Domain}/faq/more-from-heni/heni-news`,
	HeniNewsApp: 'https://apps.apple.com/gb/app/heni-news/id1622218264',
	MetaMaskDownload: 'https://metamask.io',
	MetaMaskWalletKnowledge: `${Config.Domain}/faq/wallets-blockchain-crypto?article=what-is-a-meta-mask-wallet-and-how-do-i-get-it`,
	Jobs: 'https://www.linkedin.com/company/heni-group/jobs/',
});
